export default __webpack_public_path__ + "static/media/wf-isf-economic-advantage-of-issuing-green-bonds_1164x584.a2856d62.jpg";